import React, { useState, useEffect } from 'react';

const AgeVerification = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const verified = sessionStorage.getItem('ageVerified');
    if (!verified) setShow(true);
  }, []);

  const handleVerify = () => {
    sessionStorage.setItem('ageVerified', 'true');
    setShow(false);
  };

  const handleDeny = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-[#1a1a1a] border border-[#333] rounded-2xl p-8 max-w-md w-full mx-4 text-center">
        <h2 className="text-[#c8ff00] text-2xl font-bold mb-3">Age Verification</h2>
        <p className="text-gray-300 mb-1">
          This site is intended for adults <strong className="text-white">18+ only</strong>.
        </p>
        <p className="text-gray-400 text-sm mb-6">
          By entering, you confirm you are of legal age in your country.
        </p>
        <button
          onClick={handleVerify}
          className="w-full bg-[#c8ff00] text-black font-semibold py-3.5 rounded-xl mb-3 hover:bg-[#b8ef00] transition-colors duration-200"
        >
          I am 18+
        </button>
        <button
          onClick={handleDeny}
          className="w-full border border-[#555] text-white py-3.5 rounded-xl hover:border-[#888] transition-colors duration-200"
        >
          I am under 18
        </button>
        <p className="text-gray-500 text-xs mt-4">
          Products may contain nicotine and are intended for adults 18+ only.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;
